import type { Lead } from "../types";

export const cleanupLeadForSave = (data: Lead) => {
  const email_jsonb = data.email_jsonb?.filter((e) => e?.email != null) ?? [];
  const phone_jsonb = data.phone_jsonb?.filter((p) => p?.number != null) ?? [];
  return {
    ...data,
    email_jsonb: email_jsonb.length > 0 ? email_jsonb : null,
    phone_jsonb: phone_jsonb.length > 0 ? phone_jsonb : null,
  };
};
